/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";

export const RowTopDownIcon = (props: any) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#D1FADF" />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke="#ECFDF3"
      strokeWidth="8"
    />
    <path
      d="M32.05 28.0498L37 32.9998L32.05 37.9498L30.636 36.5358L33.172 33.9988L20 33.9998V31.9998H33.172L30.636 29.4638L32.05 28.0498ZM23.95 18.0498L25.364 19.4638L22.828 21.9998H36V23.9998H22.828L25.364 26.5358L23.95 27.9498L19 22.9998L23.95 18.0498Z"
      fill="#333333"
    />
  </svg>
);
